// Port tipado de src/js/utils.js (Fase 1.0 do MODERNIZACAO.md).
// O legado continua carregando src/js/utils.js como global até a
// migração das páginas; manter os dois em sincronia até o cutover.

export function joinPath(...args: string[]): string {
  return args
    .map((part, i) => {
      if (i === 0) {
        return part.trim().replace(/[/]*$/g, '')
      }
      return part.trim().replace(/(^[/]*|[/]*$)/g, '')
    })
    .filter((x) => x.length)
    .join('/')
}
